import ScheduleCard from './ScheduleCard.jsx';

function ScheduleCardClassRoom({ scheduleData }) {
  return (
    <ScheduleCard
      scheduleData={scheduleData}
      itemKey='class_room'
      itemTitle={(item) => `Аудитория: ${item.class_room ?? item.classroom ?? 'Не указана'}`}
      renderPairMeta={(pair) => (
        <>
          <p className='teacher'>Преподаватель: {pair.teacher}</p>
          <p className='teacher'>
            Группа: {Array.isArray(pair.group_names) ? pair.group_names.join(', ') : pair.group_name}
          </p>
          <div className='pair-meta'>
            <span className='pair-type'>{pair.pair_type}</span>
            <span className='classroom'>Аудитория: {pair.class_room}</span>
          </div>
        </>
      )}
    />
  );
}

export default ScheduleCardClassRoom;